import {SharedAppStateType} from 'module/SharedAppState/reducer/SharedAppStateReducer'
import {SharedAppState} from 'module/SharedAppState/type/SharedAppState'

export const selSharedAppState = (state: SharedAppStateType) => state.SharedAppState as SharedAppState | undefined